import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRNumber extends FRBase{

    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
    }

    Parse(): any {
        let value=Number(this.Options.d);
        if(isNaN(value))
            throw new Error('Invalid number '+value);

        return value;
    }

}

FRFactory.AddField('NUM',FRNumber);